import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import ChristmasNapkins from "@/pages/ChristmasNapkins";
import PaperBagsCollection from "@/pages/PaperBagsCollection";
import PaperPlatesCollection from "@/pages/PaperPlatesCollection";
import GiftWrapCollection from "@/pages/GiftWrapCollection";
import DisposableGlassCollection from "@/pages/DisposableGlassCollection";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/christmas-napkins" element={<ChristmasNapkins />} />
          <Route path="/products/paper-bags-collection" element={<PaperBagsCollection />} />
          <Route path="/products/paper-plates-collection" element={<PaperPlatesCollection />} />
          <Route path="/products/gift-wrap-collection" element={<GiftWrapCollection /> } />
          <Route path="/products/disposable-glass-collection" element={<DisposableGlassCollection />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#1C2C22",
              color: "#F4F1EB",
              border: "1px solid #D1C9B8",
              borderRadius: 0,
              fontFamily: "Manrope, sans-serif",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
